import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import im from "../assets/img/DGHGF.png";
import Heading from "../components/Heading";
import ResponsiveImage from "./ResponsiveImage";
import imgmobile from "../assets/img/aa/events PAGE.jpg";
import imgtop from "../assets/img/aa/BANER event.jpg";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";

const Eventspage = () => {
    document.title="Events | Positive Metering"

  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState("");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get("/events/get-events");
        setEvents(response.data.responseData);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  return (
    <div>
      <Helmet>
  {/* ✅ Title */}
  <title>Company Events UAE | Project Updates & Activities | Positive Metering FZE</title>

  {/* ✅ Meta Description */}
  <meta
    name="description"
    content="Explore company events, project activities and updates from Positive Metering FZE, a trusted dosing pump supplier in UAE serving industries across MENA."
  />

  {/* ✅ Canonical */}
  <link rel="canonical" href={window.location.href} />

  {/* ✅ Open Graph */}
  <meta property="og:title" content="Events | Positive Metering" />
  <meta
    property="og:description"
    content="Explore events and activities by Positive Metering Pumps."
  />
  <meta property="og:image" content={imgtop} />
  <meta property="og:url" content={window.location.href} />
  <meta property="og:type" content="website" />
</Helmet>

      <ResponsiveImage mobileSrc={imgmobile} desktopSrc={imgtop} />
      <Heading heading="Events" />

      <Container>
        <Row>
          {events.map((event) => (
            <Col key={event.id} xs={12} lg={4} md={6} className="mb-4">
              <img
              loading="lazy"
                src={event.img}
                className="eventimg rounded-4 w-100"
                alt={event.title}
                title={event.title}
                onClick={() => handleImageClick(event.img)}
                style={{ cursor: "pointer" }}
              />
            </Col>
          ))}
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleClose} centered>    <Button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "transparent",
            border: "none",
            zIndex: 9999
          }}
        >
          <IoMdClose
            style={{
              color: "white",
              fontSize: "24px",
              backgroundColor: "transparent",
            }}
          />
        </Button>
      <Modal.Body className="p-0 d-flex justify-content-center align-items-center position-relative">
    
        <img
        loading="lazy"
          src={modalImage}
          className="img-fluid"
          alt="Event"
          title="Event"
          style={{ width: "100%", height: "auto" }}
        />
      </Modal.Body>
    </Modal>
    </div>
  );
};

export default Eventspage;
